<template>
  <CalendarPopover
    v-bind="$attrs"
    :date="date"
    :disabled="disabled"
    :from="from"
    :to="to"
    :minDate="minDate"
    :maxDate="maxDate"
    :holidayList="holidayList"
    :businessDay="businessDay"
    :isSP="isSP"
    :reserveCalendar="reserveCalendar"
    :busy="busy"
    v-on="listeners"
  >
    <div class="calendar-button" :class="{ disabled }">
      <CalendarIcon />
      {{ value ? format(value) : placeholder }}
    </div>
  </CalendarPopover>
</template>

<script>
import { formatDate, splitDate, today } from '@/utils/date'
import CalendarIcon from '@/components/icons/CalendarIcon'
import CalendarPopover from '@/components/molecules/CalendarPopover'

/**
 * カレンダー入力
 */
export default {
  name: 'CalendarInput',
  components: {
    CalendarIcon,
    CalendarPopover,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    format: { type: Function, default: date => formatDate(date, 'YYYY/M/D (dd)') },
    placeholder: { type: String, default: () => '−−−−/−−/−−(ー)' },
    /** 値 (v-model) */
    value: String,
    disabled: Boolean,
    /** 表示範囲（開始日） */
    from: { type: String, default: '2000-01-01' },
    /** 表示範囲（終了日） */
    to: { type: String, default: '2099-12-31' },
    /** 選択可能な範囲（開始日） */
    minDate: { type: String, default: '2000-01-01' },
    /** 選択可能な範囲（終了日） */
    maxDate: { type: String, default: '2099-12-31' },
    /** 祝日情報 */
    holidayList: { type: Array },
    /** 定休日情報 */
    businessDay: { type: Object, default: () => {} },
    /** SP */
    isSP: { type: Boolean, default: false },
    /** 予約数一覧 */
    reserveCalendar: { type: Object, default: () => ({}) },
    /** ローディング */
    busy: { type: Boolean, default: false },
  },
  computed: {
    date() {
      const { year, month, day } = splitDate(this.value)
      if (!year || !month || !day) return today()
      return formatDate(this.value)
    },
    listeners() {
      return {
        ...this.$listeners,
        setDate: this.setDate,
        beforeShow: this.beforeShow,
      }
    },
  },
  methods: {
    setDate(date) {
      this.$emit('setDate', date)
    },
    beforeShow() {
      this.$emit('beforeShow')
    },
  },
}
</script>

<style lang="postcss" scoped>
.calendar-button {
  align-items: center;
  background-color: var(--white);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  box-sizing: border-box;
  color: var(--text-color);
  cursor: pointer;
  display: grid;
  fill: var(--moderate-blue);
  font-size: 13px;
  grid-auto-flow: column;
  grid-gap: 8px;
  height: 40px;
  justify-content: start;
  line-height: 16px;
  min-width: 184px;
  padding: 0 8px;

  &.disabled {
    background-color: var(--mostly-white-1);
    color: var(--light-gray);
    cursor: default;
    fill: var(--light-gray);
  }

  .responsive & {
    grid-gap: 4px;
    min-width: inherit;
    width: 100%;
  }
}
</style>
